/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800&display=swap);.details[_ngcontent-%COMP%]{display:flex;justify-content:space-between}select[_ngcontent-%COMP%]:disabled{cursor:not-allowed}.hover[_ngcontent-%COMP%]:hover{cursor:pointer}.hover[_ngcontent-%COMP%]:hover   td[_ngcontent-%COMP%]{background-color:#eceeef}"];
export { styles as styles };
